import React, { useContext } from "react";
import { CssBaseline } from "@material-ui/core";
import { Context } from "../contexts/siteContext";
import Grid from '@material-ui/core/Grid';
import JournalChart from "../charts/journalChart";
import SafetyCoachingChart from "../charts/safetyCoachingChart";
import StaffingChart from "../charts/staffingChart";
import RoundChart from "../charts/roundChart";
import VisitationEVSChart from "../charts/visitationEVSChart";
import RecoveryEVSChart from "../charts/recoveryEVSChart";
import PatientSittingChart from "../charts/patientSittingChart";
import TeamCoachChart from "../charts/teamCoachChart";
import RdoAccountVisitationChart from "../charts/rdoAccountVisitationChart";
import HuddleChart from "../charts/huddleChart";
import TeamProChart from "../charts/teamProChart";

const Home = (props) => {
    const { defaultSite } = useContext(Context);
    const modules = props.modules ? props.modules : [];

    const TileItem = propsTI => {
        let module = propsTI.title;

        if (module === "Staffing") {
            return (
                <Grid item >
                    <StaffingChart />
                </Grid>
            )
        }
        else if (module === "SafetyCoaching") {
            return (
                <Grid item >
                    <SafetyCoachingChart />
                </Grid>
            )
        }
        else if (module === "Journal") {
            return (
                <Grid item >
                    <JournalChart />
                </Grid>
            )
        }
        else if (module === "Round") {
            return (
                <Grid item >
                    <RoundChart />
                </Grid>
            )
        }
        else if (module === "Coach") {
            return (
                <Grid item >
                    <TeamCoachChart />
                </Grid>
            )
        }
        else if (module === "PatientSitting") {
            return (
                <Grid item >
                    <PatientSittingChart />
                </Grid>
            )
        }
        else if (module === "VisitationEVS") {
            return (
                <Grid item >
                    <VisitationEVSChart />
                </Grid>
            )
        }
        else if (module === "Recovery") {
            return (
                <Grid item >
                    <RecoveryEVSChart />
                </Grid>
            )
        }

        return <></>
    };

    const checkTile = title => {
        return modules.filter(x => x.title === title).length > 0;
    };

    if (defaultSite && defaultSite.id && modules.length > 0) {
        return (
            <div color="primary">
                <CssBaseline />
                <Grid container
                    direction="row"
                    justify="space-evenly"
                    alignItems="flex-start"
                    spacing={2}>
                        {modules.map((item, index) => (
                            <TileItem key={index} title={item.title} />
                        ))}
                        <Grid item>
                            {checkTile('TeamPRO') && <TeamProChart />}
                            {checkTile("Huddle") && <HuddleChart />}
                            {checkTile("RDOAccountVisitation") && <RdoAccountVisitationChart />}
                        </Grid>
                </Grid>
            </div>
        );
    }
    else return (<></>);
}
export default React.memo(Home);
